import { UserList } from "../ListPage";

export const ReportsList = () => {
  return (
      <div className="userManageContainer">
      <UserList></UserList>
    </div>
  );
};
